module.exports = __webpack_public_path__ + "static/media/tipologia8.ee338348.png";